import React from "react";
import trainer1 from "../../assets/trainer1.png";
import trainer2 from "../../assets/trainer2.png";
import tick from "../../assets/tick.png";
import "./Reasons.css";
const Reasons = () => {
  return (
    <div className="Reasons" id="reasons">
      <div className="left-r">
        <img src={trainer1} alt="trainer" />
        <img src={trainer2} alt="trainer" />
      </div>
      <div className="right-r">
        <span>Trainers Section</span>
        <div>
          <span className="stroke-text">Why </span>
          <span>choose us?</span>
        </div>
        <div className="details-r">
          <div>
            <img src={tick} alt="" />
            <span>Personalized Workouts & Nutrition Plans🏋️‍♂️🥗</span>
          </div>
          <div>
            <img src={tick} alt="" />
            <span>Science-Backed & Results-Driven 📊🔥</span>
          </div>
          <div>
            <img src={tick} alt="" />
            <span>Accountability & Expert Guidance 🎯💡</span>
          </div>
          <div>
            <img src={tick} alt="" />
            <span>Holistic Approach to Fitness 🧘‍♂️💪 </span>
          </div>
          <div>
            <img src={tick} alt="" />
            <span>
              Professional trainers with deep expertise in human biomechanics
              and kinematics 🧠🦴
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reasons;
